import React, { useState } from 'react';

// Bandeau d'information : le service n'utilise que des cookies strictement
// necessaires (session/auth/pseudo). Pas de consentement requis par la loi, mais
// on informe l'utilisateur et on renvoie vers la politique de confidentialite.
export function CookieNotice() {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem('cookieNoticeAck') === '1'; } catch { return false; }
  });
  if (dismissed) return null;
  const ack = () => { try { localStorage.setItem('cookieNoticeAck', '1'); } catch {} setDismissed(true); };
  return (
    <div className="cookie-notice" role="dialog" aria-label="Information cookies">
      <span>
        On utilise seulement des cookies necessaires (session, pseudo). Aucun tracking publicitaire.{' '}
        <a href="#/privacy">En savoir plus</a>.
      </span>
      <button type="button" className="btn cookie-ok" onClick={ack}>OK</button>
    </div>
  );
}
